import React from "react";
import CandidateHeader from "./candidateHeader";

const CandidateLayout = ({ children }) => {
  return (
    <div className="g-app-shell">
      <CandidateHeader />
      {children}
    </div>
  );
};

export default CandidateLayout;
